import React, { FC } from 'react';

type Props = {
  when: boolean;
  children: React.ReactNode;
};

const Only: FC<Props> = ({ children, when = false }) => {
  return <>{when && children}</>;
};

export { Only };
